import moment from 'moment/min/moment-with-locales';
import Moment from 'react-moment';

Moment.globalMoment = moment;
Moment.globalFormat = 'D/M/YYYY';
